import http from "../http-common";

class ProductService {
    createProduct(data) {
      return http.post("product/create", data);
    }
    updateProduct(id, data) {
      return http.post(`product/update/${id}`, data);
    }
    
    getProductDetail(id) {
      return http.get(`product/detail/${id}`);
    }
    getProducts() {
        return http.get("product/list");
    }
    deleteProduct(data) {
      return http.delete("product/delete", { params: data });
    }
    getProductImages(data) {
      return http.get("product/images", { params: data });
    }
    uploadProductImages(formData) {
        return http.post("product/upload-product-images", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
    }
    deleteProductImages(data) {
        return http.delete("product/image", { params: data });
    }      
    updateBestProduct(data) {
      return http.post("product/updateBestProduct", data);
    }
}

export default new ProductService();